import { BaseRouteService } from "./BaseRouteService";

export class MapService extends BaseRouteService {
    public getCurrentRoom(): Promise<string> {
        return this.getJsonApi<string>("toon/check-location");
    }
}
